import { ENV } from '../config/env';
import { getZonedParts, localTimeToUtcDate } from './callback-slots';

export const SCHEDULE_HANDOFF_COOKIE = 'schedule_handoff';
export const SCHEDULE_COMPLETE_COOKIE = 'schedule_complete';

export const SCHEDULE_HANDOFF_MAX_AGE_SECONDS = 900;

export const isDevOrStaging = (): boolean => {
  if (process.env.NODE_ENV === 'development') return true;
  return ENV.API_BASE_URL.includes('vtstaging');
};

export const isForceAfterHoursEnabled = (searchParams: URLSearchParams): boolean => {
  if (!isDevOrStaging()) return false;
  return searchParams.get('forceAfterHours') === '1';
};

export const isAfterHoursPreviewEnabled = (searchParams: URLSearchParams): boolean => {
  if (!isDevOrStaging()) return false;
  return searchParams.get('preview') === '1';
};

export const searchParamsToURLSearchParams = (
  searchParams: Record<string, string | string[] | undefined>,
): URLSearchParams => {
  const params = new URLSearchParams();

  for (const [key, value] of Object.entries(searchParams)) {
    if (typeof value === 'string') {
      params.set(key, value);
    }
  }

  return params;
};

/**
 * Parses a preview time param (e.g. "2230", "22:30") into a Date
 * representing that wall-clock time today in the given IANA timezone.
 */
export const parsePreviewTimeParam = (
  timeParam: string | null | undefined,
  timezone: string,
  referenceDate: Date = new Date(),
): Date | null => {
  if (!timeParam) return null;

  const cleaned = timeParam.replace(':', '').trim();
  if (!/^\d{3,4}$/.test(cleaned)) return null;

  const padded = cleaned.padStart(4, '0');
  const hour = parseInt(padded.slice(0, 2), 10);
  const minute = parseInt(padded.slice(2, 4), 10);

  if (hour > 23 || minute > 59) return null;

  const parts = getZonedParts(referenceDate, timezone);

  return localTimeToUtcDate(parts.year, parts.month, parts.day, hour, minute, timezone);
};
